import React from 'react';
import PropTypes from 'prop-types';

import {addQueryParams, generateQueryString} from 'common/utils/url-util';
import DropdownButton from 'common/components/dropdown-button';

export default class CalendarizeSelector extends React.Component {
  static propTypes = {
    options: PropTypes.array.isRequired,
    param: PropTypes.string,
    selected: PropTypes.string,
  };

  static defaultProps = {
    param: 'calendarize_by',
    selected: '',
  };

  getListItems = () => {
    return this.props.options.map((option) => (
      <li
        className={this.props.selected === option[0] ? 'selected' : ''}
        key={option[0]}>
        <a
          href={addQueryParams(generateQueryString({}, [this.props.param]), {
            [this.props.param]: option[0],
          })}>
          {option[1]}
        </a>
      </li>
    ));
  };

  getSelectedText = () => {
    const selected = this.props.options.find(
      (option) => option[0] === this.props.selected,
    );
    return selected && selected[1];
  };

  render() {
    return (
      <span className={'CalendarizeSelector'}>
        <DropdownButton
          buttonChildren={this.getSelectedText()}
          buttonProps={{type: 'select'}}
          dropdownChildren={this.getListItems()}
          dropdownProps={{menuPosition: 'down-right'}}
        />
      </span>
    );
  }
}
